export const MAX_PAGE_WIDTH = '980px';

export const PLANTLIFE_GREEN = '#3E8B31';
export const PLANTLIFE_GREEN_DARK = '#0D3F28';
